import React from 'react';

const Vue_Event_Modifiers = () => {
  return (
    <div>
      <h1>Vue_Event_Modifiers Component</h1>
      <p>This is the Vue_Event_Modifiers tutorial page.</p>
    </div>
  );
}

export default Vue_Event_Modifiers;
